import { render, staticRenderFns } from "./MiniQuiz.vue?vue&type=template&id=62c65740&scoped=true"
import script from "./MiniQuiz.vue?vue&type=script&lang=js"
export * from "./MiniQuiz.vue?vue&type=script&lang=js"
import style0 from "./MiniQuiz.vue?vue&type=style&index=0&id=62c65740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c65740",
  null
  
)

export default component.exports